import { MouseEvent } from 'react';
import { SortOptions, FilterOptions } from 'helpers/Links/Links.typed';

export function safeClick(event: MouseEvent) {
  const sure = confirm('Are you sure?');
  if (!sure) {
    event.preventDefault();
  }
}

const generateSimilarCarsLink = (
  make: string,
  model: string,
  year: string,
  sort?: SortOptions,
  filter?: FilterOptions,
) => {
  let link = `/cars/${make}/${model}/${year}`;

  if (sort) {
    link += `?sort=${sort}`;
  }

  if (filter) {
    link += sort ? `&${filter}` : `?${filter}`;
  }

  return link;
};

export { generateSimilarCarsLink };
